import { useState } from 'react';

import { adminLeads } from '../api/admin';
import type { Lead } from '../types/content';
import { useCollection } from './useCollection';

const dateFormat = new Intl.DateTimeFormat('sv-SE', {
  dateStyle: 'short',
  timeStyle: 'short'
});

export default function LeadsPanel() {
  const { items, error, reload } = useCollection(adminLeads.list);
  const [selected, setSelected] = useState<Lead | null>(null);

  return (
    <>
      <div className={selected ? 'admin-layout is-editing' : 'admin-layout'}>
        <div className="admin-column">
          <div className="admin-head">
            <h2>Förfrågningar</h2>
            <button className="button secondary small" type="button" onClick={reload}>
              Uppdatera
            </button>
          </div>

          {error && <div className="state is-error">{error}</div>}

          {items?.length === 0 ? (
            <div className="state">Inga förfrågningar har kommit in ännu.</div>
          ) : (
            <div className="admin-list">
              {items?.map((lead) => (
                <div className="admin-row" key={lead.id}>
                  <div>
                    <strong>
                      {lead.name} · {lead.company}
                    </strong>
                    <div className="meta">
                      {dateFormat.format(new Date(lead.createdAt))} · {lead.topic}
                    </div>
                  </div>
                  <div className="admin-actions">
                    <button
                      className="button secondary small"
                      type="button"
                      onClick={() => setSelected(lead)}
                    >
                      Visa
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {selected && (
          <div className="admin-panel">
            <h3>{selected.name}</h3>
            <div className="contact-box">
              <div className="contact-row">
                <span>Inkom</span>
                <span>{dateFormat.format(new Date(selected.createdAt))}</span>
              </div>
              <div className="contact-row">
                <span>Företag</span>
                <span>{selected.company}</span>
              </div>
              <div className="contact-row">
                <span>Roll</span>
                <span>{selected.role}</span>
              </div>
              <div className="contact-row">
                <span>E-post</span>
                <a href={`mailto:${selected.email}`}>{selected.email}</a>
              </div>
              {selected.phone && (
                <div className="contact-row">
                  <span>Telefon</span>
                  <a href={`tel:${selected.phone}`}>{selected.phone}</a>
                </div>
              )}
              <div className="contact-row">
                <span>Område</span>
                <span>{selected.topic}</span>
              </div>
            </div>

            <div className="lead-message">{selected.message}</div>

            <div className="admin-actions">
              <a
                className="button primary"
                href={`mailto:${selected.email}?subject=${encodeURIComponent(
                  `Din förfrågan till NorthBridge One – ${selected.topic}`
                )}`}
              >
                Svara
              </a>
              <button className="button secondary" type="button" onClick={() => setSelected(null)}>
                Stäng
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
